import PropTypes from 'prop-types'

const SpaceLandingHeader = ({ children }: any) => <div className="flex">{children}</div>

SpaceLandingHeader.displayName = 'SpaceLandingHeader'

SpaceLandingHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
}

SpaceLandingHeader.defaultProps = {
  children: null
}

export default SpaceLandingHeader
